import { z } from "zod"

const safeString = z.string().optional().catch(undefined)

export const SupernovaConfigStorybook = z.object({
  designSystemId: safeString,
  sourceId: safeString,
  brandId: safeString,
  name: safeString,
  from: safeString,
})

export const SupernovaConfig = z
  .object({
    storybook: SupernovaConfigStorybook.optional().catch(undefined),
  })
  .catch({})

export type SupernovaConfigStorybook = z.infer<typeof SupernovaConfigStorybook>
export type SupernovaConfig = z.infer<typeof SupernovaConfig>
